import { Tooltip } from "@chakra-ui/react";

export const TimeDifference = ({ dateTimeString }) => {
  const calculateTimeDifference = (dateTime) => {
    const givenDate = new Date(dateTime);
    const currentDate = new Date();
    const timeDifference = currentDate - givenDate;
    const hoursDifference = timeDifference / (1000 * 60 * 60);
    if (hoursDifference >= 24) {
      const daysDifference = Math.floor(hoursDifference / 24);
      return `${daysDifference} day${daysDifference > 1 ? "s" : ""}`;
    } else {
      return `${Math.floor(hoursDifference)} hour${Math.floor(hoursDifference) !== 1 ? "s" : ""}`;
    }
  };

  const timeDiff = calculateTimeDifference(dateTimeString);

  return (
    <Tooltip label={`Created: ${new Date(dateTimeString)}`} placement="top" bg="gray.100" color="black">


      <div className="text-gray-600  font-normal">{timeDiff} ago</div>

    </Tooltip>
  );
};